import { Menu, ActionIcon } from '@mantine/core';
import {
  TrashIcon,
  PencilIcon,
  EllipsisVerticalIcon,
  CheckIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import { FC } from 'react';
import { MenuLivePostProps } from './types';
import { useTranslation } from 'next-i18next';
import { userRole } from '@utils/typesPages/types';

export const MenuLivePost: FC<MenuLivePostProps> = ({
  onClickDelete,
  onClickEdit,
  onClickRejectApprove,
  slug,
  role,
}) => {
  const { t } = useTranslation('liveBlogDetails');
  const isAdmin = role === userRole.ADMIN;

  return (
    <Menu shadow="md" position="bottom-end">
      <Menu.Target>
        <ActionIcon>
          <EllipsisVerticalIcon />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item onClick={onClickEdit} icon={<PencilIcon width={14} />}>
          {t('menu.edit')}
        </Menu.Item>
        {isAdmin && (
          <Menu.Item
            onClick={onClickDelete}
            color="red"
            icon={<TrashIcon width={14} />}
          >
            {t('menu.delete')}
          </Menu.Item>
        )}
        {isAdmin && onClickRejectApprove && (
          <Menu.Item
            color="green"
            onClick={() => onClickRejectApprove('approve', slug ?? '')}
            icon={<CheckIcon width={14} />}
          >
            {t('menu.approve')}
          </Menu.Item>
        )}
        {isAdmin && onClickRejectApprove && (
          <Menu.Item
            color="red"
            onClick={() => onClickRejectApprove('reject', slug ?? '')}
            icon={<XMarkIcon width={14} />}
          >
            {t('menu.reject')}
          </Menu.Item>
        )}
      </Menu.Dropdown>
    </Menu>
  );
};
